module.exports = __webpack_public_path__ + "img/happy-copy.55d5d7d8.jpg";